// extracted by mini-css-extract-plugin
module.exports = {"homeVideo":"homeVideo_homeVideo__e_xmt"};